/**
 * Display name for DSOK product objects (same shape as DSOK products list/detail).
 */
export function resolveProductDisplayName(product, lang) {
  const pn = product?.productName;
  if (typeof pn === "string") return pn;
  if (pn && typeof pn === "object") {
    const l = lang && pn[lang];
    if (typeof l === "string" && l.trim()) return l;
    return (
      pn.sk ||
      pn.en ||
      pn.cs ||
      pn.de ||
      Object.values(pn).find((v) => typeof v === "string" && v.trim()) ||
      ""
    );
  }
  return "";
}

/**
 * Normalize API response from getDSOKProducts() — object map or array — to an array
 * (same pattern as DSOKProducts.js).
 */
export function normalizeDsokProductsList(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  return Object.keys(raw).map((id) => ({
    ...raw[id],
    _id: raw[id]?._id ?? id,
  }));
}

/**
 * Product id list from voucher API body — supports `productIds`, `products`, legacy `productId`.
 */
export function normalizeProductIdsFromVoucherApi(apiData) {
  if (!apiData || typeof apiData !== "object") return [];
  if (Array.isArray(apiData.productIds)) {
    return apiData.productIds
      .map((x) => (x != null ? String(x).trim() : ""))
      .filter(Boolean);
  }
  if (Array.isArray(apiData.products)) {
    const out = [];
    apiData.products.forEach((x) => {
      if (x == null) return;
      if (typeof x === "string") {
        const s = x.trim();
        if (s) out.push(s);
        return;
      }
      if (typeof x === "object") {
        const id = x.productId ?? x._id ?? x.id ?? x.product?._id ?? "";
        if (id != null && String(id).trim() !== "") {
          out.push(String(id).trim());
        }
      }
    });
    return out;
  }
  if (apiData.productId != null && String(apiData.productId).trim() !== "") {
    return [String(apiData.productId).trim()];
  }
  if (
    apiData.ticketProductId != null &&
    String(apiData.ticketProductId).trim() !== ""
  ) {
    return [String(apiData.ticketProductId).trim()];
  }
  return [];
}

/** Initial DSOK product id from persisted series (`productIds[0]`, `productId`, or `ticketProductId`). */
export function inferProductIdFromSeries(series) {
  if (!series) return "";
  if (Array.isArray(series.productIds) && series.productIds.length > 0) {
    return String(series.productIds[0]);
  }
  if (series.productId) return String(series.productId);
  if (series.ticketProductId) return String(series.ticketProductId);
  return "";
}
